import { render, staticRenderFns } from "./OrganismAnchors.vue?vue&type=template&id=7f2242b4&"
import script from "./OrganismAnchors.vue?vue&type=script&lang=js&"
export * from "./OrganismAnchors.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAnchors.vue?vue&type=style&index=0&id=7f2242b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCommonMoleculeAnchor: require('/app/components/molecules/common/MoleculeAnchor.vue').default})
